// extracted by mini-css-extract-plugin
module.exports = {"flex":"WithPriceChart_flex__FnFnc","content":"WithPriceChart_content__1GdI3","chart":"WithPriceChart_chart__3CAdL","load":"WithPriceChart_load__1L_rQ"};